import request from '@/utils/request'

// 查询配色物料关系配置列表
export function apiMaterialMatchColorConfigList (query) {
  return request({
    url: '/mdm/materialMatchColorConfig/list',
    method: 'get',
    params: query
  })
}

// 新增配色物料关系配置
export function apiMaterialMatchColorConfigAdd (data) {
  return request({
    url: '/mdm/materialMatchColorConfig',
    method: 'post',
    data: data
  })
}

// 删除配色物料关系配置
export function apiMaterialMatchColorConfigDel (ids) {
  return request({
    url: `/mdm/materialMatchColorConfig/${ids}`,
    method: 'delete'
  })
}

// 修改
export function apiMaterialMatchColorConfigEdit (data) {
  return request({
    url: '/mdm/materialMatchColorConfig',
    method: 'put',
    data: data
  })
}

// 导出配色物料关系配置列表V2
export function apiMaterialMatchColorConfigExport (data) {
  return request({
    url: '/mdm/materialMatchColorConfig/v2/export',
    method: 'post',
    data: data
  })
}
